// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__bKpus","errors":"Errors_errors__2Dvjh"};